import { useState, useContext, useEffect } from "react";
import EmailOrMobileVerification from "./EmailOrMobileVerification";
import OtpVerification from "./OtpVerification";
import { useTranslation } from "react-i18next";
import { FireBaseContext } from "../../../contexts/FireBase";
import { Typography } from "@mui/material";

const customStyles = {
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    "& > p": {
      color: "rgb(80, 80, 80)",
      fontWeight: "bold",
      fontSize: "1.5rem",
      margin: 0,
    },
  },
};

function Login() {
  const [activeStep, setActiveStep] = useState(1);
  const [userInfo, setUserInfo] = useState({});
  const { t } = useTranslation();
  const { logEvent, isAppMounted } = useContext(FireBaseContext);

  useEffect(() => {
    if (!isAppMounted) logEvent("VisitAbjadiyatHOD");
  }, [isAppMounted]);

  return (
    <Typography component="div" sx={customStyles.root}>
      <p>{t("Sign In")}</p>
      {activeStep === 1 ? (
        <EmailOrMobileVerification
          userInfo={userInfo}
          setActiveStep={setActiveStep}
          setUserInfo={setUserInfo}
        />
      ) : (
        <OtpVerification userInfo={userInfo} setActiveStep={setActiveStep} />
      )}
    </Typography>
  );
}

export default Login;
